import {inject, injectable} from 'inversify';

import type {IApiDataMapper} from '../../../ports/types';
import type {SubtenantArticlesAccessModel} from '../SubtenantArticlesAccess.model';
import type {SubtenantMapperJrpc} from './Subtenant.mapper.jrpc';

import {SubtenantArticlesAccessModelFactory} from '../SubtenantArticlesAccess.factory';

@injectable()
export class SubtenantArticlesAccessMapperJrpc
  implements
    IApiDataMapper<
      // @ts-expect-error: it requires id field
      SubtenantArticlesAccessMapperJrpc.ApiData,
      SubtenantArticlesAccessModel.Props,
      SubtenantArticlesAccessModel
    >
{
  constructor(
    @inject(SubtenantArticlesAccessModelFactory)
    private readonly factory: SubtenantArticlesAccessModelFactory,
  ) {}

  mapDataToModel(
    apiData: SubtenantArticlesAccessMapperJrpc.ApiData,
  ): SubtenantArticlesAccessModel {
    return this.factory.create(this.mapDataToProps(apiData));
  }

  mapDataToProps(
    apiData: SubtenantArticlesAccessMapperJrpc.ApiData,
  ): SubtenantArticlesAccessModel.Props {
    const config: SubtenantArticlesAccessModel.Props = {
      hasAccess: false,
      hasPremiumAccess: false,
      id: '',
    };

    if ((apiData?.length || 0) > 0) {
      config.hasAccess = true;
    }

    if (apiData?.includes('premium')) {
      config.hasPremiumAccess = true;
    }

    return config;
  }

  mapModelToApiData(
    model: SubtenantArticlesAccessModel,
  ): SubtenantArticlesAccessMapperJrpc.ApiData {
    const apiData: SubtenantArticlesAccessMapperJrpc.ApiData = [];

    if (model.hasAccess) {
      apiData.push('free');
    }

    if (model.hasPremiumAccess) {
      apiData.push('premium');
    }

    return apiData;
  }
}

export namespace SubtenantArticlesAccessMapperJrpc {
  export type ApiData = SubtenantMapperJrpc.ApiData['subscribed_to'];
}
